const row = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: 32,
  paddingRight: 32,
  '& *': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  '&:hover': {
    background: 'rgb(243, 250, 254)',
    cursor: 'pointer',
    color: '#148CFC',
  },
  '& svg': {
    marginRight: 8,
  },
};

const style = () => ({
  search: {
    marginLeft: 'auto',
    minWidth: 380,
  },

  root: {
    paddingLeft: 0,
  },

  noCategoryName: {
    paddingLeft: 0,
    '& $collectionName': {
      paddingLeft: 8,
    },
    '& $segment': {
      paddingLeft: 40,
    },
  },

  table: {
    userSelect: 'none',
    borderCollapse: 'collapse',
    width: '100%',
    overflow: 'auto',
    maxHeight: 'calc(100vh - 460px)',
    minHeight: 200,
  },

  categoryName: {
    ...row,
    height: 40,
    paddingLeft: 8,
  },

  categoryTile: {
    width: 24,
    height: 24,
    marginRight: 8,
  },

  collectionName: {
    ...row,
    paddingLeft: 30,
    '&:hover svg *': {
      fill: '#148CFC',
    },
  },

  segment: {
    ...row,
    justifyContent: 'space-between',
    paddingLeft: 72,
    '&:hover svg path': {
      fill: '#148CFC',
    },
  },

  destinations: {
    fontSize: 14,
    color: '#778C9A',
    lineHeight: 14,
    textAlign: 'right',
    flexGrow: 1,
  },

  segmentIconWrapper: {
    width: 28,
  },

  segmentIcon: {
    position: 'relative',
    top: -1,
    '& *': {
      fill: '#9BADBC',
    },
  },

  searchIcon: {
    marginLeft: 12,
    width: 14,
    height: 14,
  },

  segmentName: {
    ...row,
    whiteSpace: 'pre',
    width: '50%',
    '& svg': {
      marginRight: 8,
    },
  },

  resultsCount: {
    fontSize: 14,
    textAlign: 'left',
    minWidth: 80,
    color: '#728C9C',

    '& svg': {
      marginRight: 6,
      '& *': {
        fill: '#9BADBC',
      },
    },
  },

  footer: {
    padding: 8,
    borderTop: '1px solid #E1E9F0',
    '& > *': {
      margin: '0px 8px',
    },
  },
});

export default style;
